import { render, staticRenderFns } from "./UserProfilePanel.vue?vue&type=template&id=18d02f94&scoped=true&"
import script from "./UserProfilePanel.vue?vue&type=script&lang=js&"
export * from "./UserProfilePanel.vue?vue&type=script&lang=js&"
import style0 from "./UserProfilePanel.vue?vue&type=style&index=0&id=18d02f94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d02f94",
  null
  
)

export default component.exports